import React, { FC } from "react";
import { Table, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useVrmNewMaintenanceDetailsModel } from "../vrmNewBillmaintenanceModel";
import { RouterParamType } from "@/model/navModel";
import { IMaterialDetailList } from "../vrmNewBillmaintenanceType";

export const MaterialTableBox: FC<RouterParamType> = () => {
    const { detailMaterialLookList, } = useVrmNewMaintenanceDetailsModel();
    const MaterialColumns: ColumnsType<IMaterialDetailList> = [
        {
            title: '序号',
            width: 60,
            fixed: "left",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
            // render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={() => onHistoryModel(record)}>{text}</p></Tooltip>,
            fixed: "left",
        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
            fixed: "left",

        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '数量',
            width: 100,
            dataIndex: 'num',
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
        }, {
            title: '配件费',
            width: 100,
            dataIndex: 'materialAmount',
        }, {
            title: '折扣',
            width: 100,
            dataIndex: 'discountRate',
            render: (text: string) => text + "%"
        }, {
            title: '折后单价',
            width: 100,
            dataIndex: 'discountedPrice',
        }, {
            title: '小计',
            width: 100,
            dataIndex: 'receivableAmount',
        }, {
            title: '库房',
            width: 160,
            dataIndex: 'warehouseName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,

        }, {
            title: '货位',
            width: 160,
            dataIndex: 'shelfCode',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '可用库存',
            width: 160,
            dataIndex: 'inventoryNum',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
        }
    ];


    return (
        <YhBox title="维修用料" style={{ marginBottom: "75px" }}>
            <Table
                rowKey={record => record.detailsId as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={MaterialColumns}
                dataSource={detailMaterialLookList}
                pagination={false}
                scroll={{ x: 'max-content', y: 300 }}
            />
        </YhBox>
    )
}